"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { BrandPulse } from "@/components/brand-pulse";
import { authClient } from "@/lib/auth";

// Client-side gate for pages that need a signed-in parent: the console has no
// public content, so signed-out visitors are sent to /sign-in instead of
// seeing a sign-in button. UX only — the real gate is the console API
// enforcing the session cookie on every route.
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data: session, isPending } = authClient.useSession();
  const router = useRouter();

  useEffect(() => {
    if (!isPending && !session) router.replace("/sign-in");
  }, [isPending, session, router]);

  // Pulse while the session loads and for the frame before the redirect
  // lands — the guarded content never flashes for signed-out visitors.
  // Guards whole route groups, so it stays page-agnostic.
  if (!session) return <BrandPulse />;
  return <>{children}</>;
}
